import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Box,
    Typography,
    Grid
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MobileColorInfoBox from './MobileColorInfoBox';



const MobileColorBoxDialog = ({
    open,
    onClose,
    color,
    comparingAgainst,
    comparingAgainstScaled,
    numberOfDays,
    loading,
    loadingComparison,
    isLayoutMode
}) => {
    if (!color) {
        return null;
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={false}
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 2,
                    maxHeight: '40vh',
                    minHeight: '35vh',
                    width: '100vw',
                    margin: 0
                }
            }}
        >
            <DialogTitle sx={{
                pt: 0.7,
                pb: 0.5,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                borderBottom: '1px solid #e0e0e0'
            }}>
                <Typography variant="subtitle1" fontWeight="bold" sx={{ fontSize: '1rem' }}>
                    Comparison Details
                </Typography>
                <IconButton onClick={onClose} size="small">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ pt: 2, mt: 0.5 }}>
                <Grid container spacing={0}>
                    {/* Left Side - MobileColorInfoBox */}
                    <Grid item xs={12}>
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100%'
                        }}>
                            <MobileColorInfoBox
                                style={{ right: "7%" }}
                                loading={loading || loadingComparison}
                                isLayoutMode={isLayoutMode}
                                isMobile={true}
                                comparingAgainst={comparingAgainst}
                                comparingAgainstScaled={comparingAgainstScaled}
                                numberOfDays={numberOfDays}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default MobileColorBoxDialog; 